module.exports = __webpack_public_path__ + "static/media/idea.8c883bee.png";